import React, { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { Icon } from 'components/common/Icon';
import { useProxyHealth } from '../use-proxy-health';
import { checkCircleIcon, xCircleIcon } from 'assets/icons';
import { RequestStatus } from 'react-app-env';
import axios from 'axios';

type FeatureFlag = {
  name: string,
  enabled: boolean,
  variant: { name: string, enabled: boolean }
}

const FeatureAdmin = () => {
  const [proxyStatus, proxyStatusMessage] = useProxyHealth();
  const [status, setStatus] = useState<RequestStatus>('Loading');
  const [error, setError] = useState<string | undefined>(undefined);
  const [flags, setFlags] = useState<FeatureFlag[]>([]);

  useEffect(() => {
    setStatus('Loading');
    if (proxyStatus === 'Error') {
      setStatus('Error');
      setError(`Error in proxy: ${JSON.stringify(proxyStatusMessage)}`);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      axios.get(process.env.UNLEASH_PROXY_URL!, { headers: { Authorization: `${process.env.UNLEASH_PROXY_SECRET}` } })
        .then(res => res.data)
        .then(json => {
          setStatus('Ok');
          setFlags(json.toggles);
        })
        .catch(async res => {
          setStatus('Error');
          setError(res.data);
        });
    }
  }, [proxyStatus]);

  return <div className='w-auto'>
    <div className='mb-4'>Feature flags should be toggled using GitLab.</div>
    <div>Disabled feature flags may not be displayed.</div>
    {status === 'Loading'
      && <ReactLoading className='m-auto' type={'bubbles'} color={'#ac542e'} height={'50%'} width={'8%'} />}
    {status === 'Error'
      && <div className='text-red-600'>{error}</div>}
    {status === 'Ok' && <table className='mx-auto content-center divide-y divide-gray-200 w-3/5 mt-4 mb-8'>
      <thead className='bg-gray-50 font-extrabold'>
        <tr>
          <th
            scope="col"
            className='px-2 py-1 md:px-6 md:py-3 text-xs md:text-s text-center text-gray-500 uppercase tracking-wider'>
              Feature flag
          </th>
          <th
            scope="col"
            className='px-2 py-1 md:px-6 md:py-3 text-xs md:text-s text-center text-gray-500 uppercase tracking-wider'>
              Enabled
          </th>
        </tr>
      </thead>
      <tbody>
        {flags && flags.map(({ name, enabled }) => {
          return <tr key={name}>
            <td>{name}</td>
            <td>
              <Icon
                src={enabled ? checkCircleIcon : xCircleIcon}
                title={enabled ? 'Enabled' : 'Disabled'} />
            </td>
          </tr>;
        })}
      </tbody>
    </table>}
  </div>;
};

export default FeatureAdmin;
